class CartDrawerEnhanced {
  constructor() {
    this.currentReviewIndex = 0;
    this.totalReviews = 3;
    this.init();
  }

  init() {
    this.initReviewsSlider();
    this.initAddToCartButtons();
    this.initProductOptions();
  }

  initReviewsSlider() {
    const prevButton = document.querySelector('.cart-drawer__reviews-nav--prev');
    const nextButton = document.querySelector('.cart-drawer__reviews-nav--next');
    const track = document.querySelector('.cart-drawer__reviews-track');

    if (!prevButton || !nextButton || !track) return;

    prevButton.addEventListener('click', () => {
      this.currentReviewIndex = this.currentReviewIndex > 0 
        ? this.currentReviewIndex - 1 
        : this.totalReviews - 1;
      this.updateSlider();
    });

    nextButton.addEventListener('click', () => {
      this.currentReviewIndex = this.currentReviewIndex < this.totalReviews - 1 
        ? this.currentReviewIndex + 1 
        : 0;
      this.updateSlider();
    });

    // Auto-advance slider every 5 seconds
    setInterval(() => {
      this.currentReviewIndex = this.currentReviewIndex < this.totalReviews - 1 
        ? this.currentReviewIndex + 1 
        : 0;
      this.updateSlider();
    }, 5000);
  }

  updateSlider() {
    const track = document.querySelector('.cart-drawer__reviews-track');
    if (track) {
      const translateX = -this.currentReviewIndex * 100;
      track.style.transform = `translateX(${translateX}%)`;
    }
  }

  initAddToCartButtons() {
    const addToCartButtons = document.querySelectorAll('.cart-drawer__add-to-cart');
    
    addToCartButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const productId = button.dataset.productId;
        this.addProductToCart(productId, button);
      });
    });
  }

  initProductOptions() {
    const optionSelects = document.querySelectorAll('.cart-drawer__option-select');
    
    optionSelects.forEach(select => {
      select.addEventListener('change', (e) => {
        // Handle option changes if needed
        console.log('Option changed:', e.target.value);
      });
    });
  }

  async addProductToCart(productId, button) {
    if (!productId) return;

    // Show loading state
    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    try {
      // Get the variant ID from the button
      const variantId = button.dataset.variantId;
      
      if (!variantId) {
        throw new Error('Variant not found');
      }

      // Add to cart
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      // Update cart drawer
      await this.updateCartDrawer();
      
      // Show success state
      button.textContent = 'Added!';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);

    } catch (error) {
      console.error('Error adding to cart:', error);
      button.textContent = 'Error';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);
    }
  }


  async updateCartDrawer() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      // Update cart count
      const cartCountElements = document.querySelectorAll('.cart-count-bubble');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });

      // If cart is no longer empty, refresh the drawer
      if (cart.item_count > 0) {
        window.location.reload();
      }
    } catch (error) {
      console.error('Error updating cart drawer:', error);
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CartDrawerEnhanced();
});

// Also initialize when cart drawer is opened
document.addEventListener('cart:drawer-opened', () => {
  new CartDrawerEnhanced();
});
